module.exports = "<div class=\"loading\" *ngIf=\"display\"></div>"